import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const {
    primary: { dark, main },
    common
  } = theme.palette;

  return {
    searchInputBase: {
      display: "flex",
      marginBottom: 10,
      paddingRight: 22
    },
    searchInput: {
      padding: "0 16px 0 0",
      height: 50,
      fontSize: 14,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: 40
      }
    },
    searchIcon: {
      color: dark,
      fontSize: 18
    },
    clearSearchIcon: {
      color: main
    },
    searchResults: {
      height: "calc(100dvh - 436px)",
      overflow: "auto",
      margin: "0 0 0 -12px",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        height: "calc(100dvh - 322px)"
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: "calc(100dvh - 236px)"
      },
      [theme.heightBreakpoints.down(400)]: {
        height: "auto"
      }
    },
    listItem: {
      padding: "8px 10px",
      background: common.white,
      borderBottom: "1px solid #d7d7d7",
      borderRadius: 0,
      minHeight: 60,
      width: "100%",
      lineHeight: "20px",
      alignItems: "center",
      "&:hover": {
        background: common.white
      },
      "& .MuiButton-label": {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        width: "100%",
        [theme.breakpoints.up(Breakpoints.SM_600)]: {
          gridTemplateColumns: "repeat(3, 1fr) 90px"
        }
      },
      "&:nth-child(odd)": {
        background: "#fafafa",
        "&:hover": {
          background: "#fafafa"
        }
      }
    },
    listItemCell: {
      textAlign: "start",
      padding: 6,
      textTransform: "capitalize",
      wordBreak: "break-all",
      "&:last-child": {
        whiteSpace: "nowrap"
      }
    },
    noContent: {
      height: "auto",
      paddingTop: "25%"
    }
  };
});
